import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { updateFaq, addFaq, getFaqs } from "../../api/faq";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();

  const getWorkQuery = useQuery({
    queryKey: [{ id }],
    queryFn: getFaqs,
    enabled: !!id,
  });

  const updateWorkQuery = useMutation({ mutationFn: updateFaq });
  const addWorkItemQuery = useMutation({ mutationFn: addFaq });

  const initialValues = useMemo(() => {
    const [workAddData] = getWorkQuery?.data?.data?.data || [];
    return {
      ques: workAddData?.ques || "",
      ans: workAddData?.ans || "",
      is_published: workAddData?.is_published,
    };
  }, [getWorkQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      ques: values?.ques || "",
      ans: values?.ans || "",
      is_published: values?.is_published,
    };

    if (id) {
      payload.id = id;
      updateWorkQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
        },
      });
      return;
    }
    addWorkItemQuery.mutate(payload, {
      onSuccess: () => {
        navigate(-1);
        toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_ADDED_SUCCESSFULLY);
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
        id,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
